import { isSameDay } from 'date-fns';

import { isDateAllowed } from './isDateAllowed';

export const testEndDate = (
  startDate: Date | null,
  minEndDate: Date | undefined,
  endDate: Date | null,
  disabledDates: Date[]
): boolean => {
  if (!endDate) {
    return true;
  }

  // Check if endDate is before minEndDate
  if (minEndDate && endDate < minEndDate) {
    return false;
  }

  if (!isDateAllowed(endDate, disabledDates)) {
    return false;
  }

  if (!startDate) {
    return true;
  }

  if (isSameDay(startDate, endDate)) {
    return true;
  }

  // Check if endDate is before startDate
  if (endDate < startDate) {
    return false;
  }

  return true;
};
